// Carrossel de avaliações
document.addEventListener('DOMContentLoaded', async () => {
    const menuBtn = document.getElementById('mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    if (menuBtn && mobileMenu) {
        menuBtn.addEventListener('click', function() {
            mobileMenu.classList.toggle('closed');
        });
        // Fecha o menu ao clicar em um link
        mobileMenu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                mobileMenu.classList.add('closed');
            });
        });
    }
    // Carrega as avaliações do arquivo JSON
    try {
        const response = await fetch('/data/1755035654101.json');
        const avaliacoes = await response.json();
        
        // Elementos do DOM
        const avaliacoesSection = document.getElementById('avaliacoes');
        if (!avaliacoesSection) return;
        const avaliacoesContainer = avaliacoesSection.querySelector('#avaliacao-container-root');
        const avaliacaoTemplate = avaliacoesContainer.querySelector('.avaliacao-container');
        
        // Botões de navegação
        const prevButton = avaliacoesContainer.querySelector('button.absolute.-left-4');
        const nextButton = avaliacoesContainer.querySelector('button.absolute.-right-4');
        
        let currentIndex = 0;
        
        // Função para mostrar uma avaliação específica
        function showAvaliacao(index) {
            // Garante que o índice esteja dentro dos limites
            if (index < 0) index = avaliacoes.length - 1;
            if (index >= avaliacoes.length) index = 0;
            
            currentIndex = index;
            const avaliacao = avaliacoes[index];
            
            // Verifica se a avaliação tem os dados necessários
            if (!avaliacao) return;
            
            // Imagem do usuário com cache
            const imageElement = avaliacaoTemplate.querySelector('#avaliacao-foto');
            if (avaliacao.photoUrl) {
                const imageName = getImageNameFromUrl(avaliacao.photoUrl);
                const cachedImagePath = `data/images/${imageName}`;

                // Corrige loop infinito: só tenta a URL original uma vez
                imageElement.onerror = null; // Limpa handler anterior
                imageElement.src = cachedImagePath;
                imageElement.alt = `Foto de ${avaliacao.name}`;
                imageElement.onerror = function handler() {
                    imageElement.onerror = null; // Evita loop
                    imageElement.src = avaliacao.photoUrl;
                };
            }
            
            // Nome
            const nameElement = avaliacaoTemplate.querySelector('#avaliacao-nome');
            if (nameElement && avaliacao.name) {
                nameElement.textContent = avaliacao.name;
            }
            
            // Estrelas de avaliação
            const starsContainer = avaliacaoTemplate.querySelector('#avaliacao-estrelas');
            if (starsContainer && avaliacao.ratingStars) {
                // Limpa as estrelas anteriores
                starsContainer.innerHTML = '';
                
                // Adiciona as estrelas de acordo com a avaliação
                for (let i = 0; i < 5; i++) {
                    const starSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    starSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                    starSvg.setAttribute('width', '24');
                    starSvg.setAttribute('height', '24');
                    starSvg.setAttribute('viewBox', '0 0 24 24');
                    starSvg.setAttribute('fill', 'none');
                    starSvg.setAttribute('stroke', 'currentColor');
                    starSvg.setAttribute('stroke-width', '2');
                    starSvg.setAttribute('stroke-linecap', 'round');
                    starSvg.setAttribute('stroke-linejoin', 'round');
                    starSvg.classList.add('w-6', 'h-6', i < avaliacao.ratingStars ? 'text-yellow-400' : 'text-gray-300', 'fill-current');
                    
                    const polygon = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
                    polygon.setAttribute('points', '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2');
                    
                    starSvg.appendChild(polygon);
                    starsContainer.appendChild(starSvg);
                }
            }
            
            // Texto da avaliação
            const reviewTextElement = avaliacaoTemplate.querySelector('#avaliacao-texto');
            if (reviewTextElement && avaliacao.reviewText) {
                reviewTextElement.textContent = `"${avaliacao.reviewText}"`;
            }

            // Atualiza os indicadores
            updateIndicators(index);
        }
        
        // Manipuladores de eventos para os botões de navegação
        prevButton.addEventListener('click', () => {
            showAvaliacao(currentIndex - 1);
            resetAutoCarousel(); // Reinicia o temporizador quando o usuário clica
        });
        
        nextButton.addEventListener('click', () => {
            showAvaliacao(currentIndex + 1);
            resetAutoCarousel(); // Reinicia o temporizador quando o usuário clica
        });
        
        // Função auxiliar para extrair o nome da imagem da URL
        function getImageNameFromUrl(url) {
            const urlParts = url.split('/');
            const filename = urlParts[urlParts.length - 1];
            return filename;
        }
        
        // Configuração do carrossel automático
        let carouselInterval;
        const autoCarouselDelay = 10000; // Tempo em ms entre as transições automáticas (10 segundos)

        // Função para iniciar o carrossel automático
        function startAutoCarousel() {
            
            carouselInterval = setInterval(() => {
                // Aplicar animação de desvanecimento
                const avaliacaoElement = avaliacaoTemplate;
                avaliacaoElement.classList.add('avaliacao-fade-out');
                
                // Mudar para a próxima avaliação após a animação de saída
                setTimeout(() => {
                    showAvaliacao(currentIndex + 1);
                    avaliacaoElement.classList.remove('avaliacao-fade-out');
                    avaliacaoElement.classList.add('avaliacao-fade-in');
                    
                    // Remover a classe após a animação terminar
                    setTimeout(() => {
                        avaliacaoElement.classList.remove('avaliacao-fade-in');
                    }, 500);
                }, 500);
            }, autoCarouselDelay);
        }
        
        // Função para resetar o temporizador do carrossel
        function resetAutoCarousel() {
            clearInterval(carouselInterval);
            startAutoCarousel();
        }
        
        // Pausar o carrossel quando o usuário passa o mouse sobre ele
        avaliacaoTemplate.addEventListener('mouseenter', () => {
            clearInterval(carouselInterval);
        });
        
        // Retomar o carrossel quando o usuário retira o mouse
        avaliacaoTemplate.addEventListener('mouseleave', () => {
            startAutoCarousel();
        });
        
        // Adicionar efeitos visuais aos botões de controle
        [prevButton, nextButton].forEach(button => {
            button.addEventListener('mouseenter', () => {
                button.style.transform = 'scale(1.1)';
            });
            
            button.addEventListener('mouseleave', () => {
                button.style.transform = 'scale(1)';
            });
            
            button.addEventListener('click', () => {
                // Efeito de clique
                button.style.transform = 'scale(0.95)';
                setTimeout(() => {
                    button.style.transform = 'scale(1.1)';
                }, 100);
            });
        });
        
        // Adicionar indicadores de posição ao carrossel
        function createIndicators() {
            // Criar container para os indicadores
            const indicatorsContainer = document.createElement('div');
            indicatorsContainer.className = 'flex justify-center gap-2 mt-6';
            avaliacoesContainer.appendChild(indicatorsContainer);
            
            // Criar um indicador para cada avaliação (limitando a 10 para não sobrecarregar)
            const maxIndicators = Math.min(avaliacoes.length, 10);
            
            for (let i = 0; i < maxIndicators; i++) {
                const indicator = document.createElement('div');
                indicator.className = 'w-2 h-2 rounded-full bg-gray-300 transition-all duration-300';
                
                // Marcar o primeiro indicador como ativo
                if (i === 0) {
                    indicator.classList.add('bg-blue-medium', 'scale-125');
                }
                
                // Adicionar evento de clique para ir diretamente para uma avaliação
                indicator.addEventListener('click', () => {
                    showAvaliacao(i);
                    resetAutoCarousel();
                });
                
                indicatorsContainer.appendChild(indicator);
            }
        }
        
        // Função para atualizar os indicadores quando a avaliação muda
        function updateIndicators(index) {
            const indicators = avaliacoesContainer.querySelectorAll('.flex.justify-center.gap-2.mt-6 div');
            if (!indicators.length) return;
            
            // Limitar o índice ao número de indicadores
            const activeIndex = index % indicators.length;
            
            // Atualizar classes dos indicadores
            indicators.forEach((indicator, i) => {
                if (i === activeIndex) {
                    indicator.classList.add('bg-blue-medium', 'scale-125');
                    indicator.classList.remove('bg-gray-300');
                } else {
                    indicator.classList.remove('bg-blue-medium', 'scale-125');
                    indicator.classList.add('bg-gray-300');
                }
            });
        }
        
        
        // Criar indicadores
        createIndicators();
        
        // Mostra a primeira avaliação
        showAvaliacao(0);
        
        // Inicia o carrossel automático
        startAutoCarousel();
        
    } catch (error) {
        console.error('Erro ao carregar avaliações:', error);
    }
});

// Função para detectar se é mobile
function isMobile() {
    return window.innerWidth <= 768;
}